import './src/styles/style.scss';
import React from 'react';
import AppContextProvider from './src/context/AppContextProvider';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

export const wrapRootElement = ({ element }) => {
    return (
        <PostHogProvider client={posthog}>
            <AppContextProvider>{element}</AppContextProvider>
        </PostHogProvider>
    );
};

// Load analytics scripts after the page is interactive
export const onClientEntry = () => {
    // Always start at the top on refresh — disable the browser's scroll restoration.
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }

    // Wait for the page to be fully loaded before loading analytics
    if (document.readyState === 'complete') {
        loadAnalytics();
    } else {
        window.addEventListener('load', loadAnalytics);
    }
};

// Force scroll to top after the page has finished hydrating on initial load.
export const onInitialClientRender = () => {
    window.scrollTo(0, 0);
};

function loadAnalytics() {
    if (process.env.GATSBY_SITE_URL === 'https://elumity.com') {
        loadGoogleTagManager();
    }

    if (process.env.GATSBY_ENABLE_POSTHOG_ANALYTICS === 'true') {
        loadPostHogAnalytics();
    }
}

function loadGoogleTagManager() {
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-KFLMDN5Z');
}

function loadPostHogAnalytics() {
    posthog.init(process.env.GATSBY_POSTHOG_API_KEY, {
        api_host: process.env.GATSBY_POSTHOG_HOST || 'https://us.i.posthog.com',
        autocapture: {
            dom_event_allowlist: ['click', 'change', 'submit'],
            url_allowlist: undefined,
            element_allowlist: undefined,
            css_selector_allowlist: undefined,
            capture_copied_text: true
        },
        capture_pageview: true,
        capture_pageleave: true,
        disable_session_recording: true
    });
}
